export const ACTIVATION_BEGIN = 'ACTIVATION_BEGIN';
export const ACTIVATION_CLEAR = 'ACTIVATION_CLEAR';
export const ACTIVATION_FAILURE = 'ACTIVATION_FAILURE';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const LOGIN_BEGIN = 'LOGIN_BEGIN';
export const LOGIN_CLEAR = 'LOGIN_CLEAR';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const PASSWORD_EMAIL_BEGIN = 'PASSWORD_EMAIL_BEGIN';
export const PASSWORD_EMAIL_CLEAR = 'PASSWORD_EMAIL_CLEAR';
export const PASSWORD_EMAIL_FAILURE = 'PASSWORD_EMAIL_FAILURE';
export const PASSWORD_EMAIL_SUCCESS = 'PASSWORD_EMAIL_SUCCESS';
export const PASSWORD_RESET_BEGIN = 'PASSWORD_RESET_BEGIN';
export const PASSWORD_RESET_CLEAR = 'PASSWORD_RESET_CLEAR';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const REGISTRATION_BEGIN = 'REGISTRATION_BEGIN';
export const REGISTRATION_CLEAR = 'REGISTRATION_CLEAR';
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_SUPERUSER = 'SET_SUPERUSER';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const UPLOAD_PRODUCT_UPDATE_TEMPLATE_FILE = 'UPLOAD_PRODUCT_UPDATE_TEMPLATE_FILE';
export const UPLOAD_PLOF_FILE = 'UPLOAD_PLOF_FILE';
export const UPLOAD_BOOKKEEPING_FILE = 'UPLOAD_BOOKKEEPING_FILE';
export const GENERATE_PRODUCTS_TABLE_BEGIN = 'GENERATE_PRODUCTS_TABLE_BEGIN';
export const GENERATE_PRODUCTS_TABLE_SUCCESS = 'GENERATE_PRODUCTS_TABLE_SUCCESS';
export const GENERATE_PRODUCTS_TABLE_FAILURE = 'GENERATE_PRODUCTS_TABLE_FAILURE';
export const SET_PRODUCTS_TABLE_DATA = 'SET_PRODUCTS_TABLE_DATA';
export const SAVE_PRODUCTS_CHANGES_BEGIN = 'SAVE_PRODUCTS_CHANGES_BEGIN';
export const SAVE_PRODUCTS_CHANGES_SUCCESS = 'SAVE_PRODUCTS_CHANGES_SUCCESS';
export const SAVE_PRODUCTS_CHANGES_FAILURE = 'SAVE_PRODUCTS_CHANGES_FAILURE';
export const SET_GENERATED_UPDATE_ENTITY_ID = 'SET_GENERATED_UPDATE_ENTITY_ID';
export const DOWNLOAD_PRODUCT_UPDATE_FILES_BEGIN = 'DOWNLOAD_PRODUCT_UPDATE_FILES_BEGIN';
export const DOWNLOAD_PRODUCT_UPDATE_FILES_SUCCESS = 'DOWNLOAD_PRODUCT_UPDATE_FILES_SUCCESS';
export const DOWNLOAD_PRODUCT_UPDATE_FILES_FAILURE = 'DOWNLOAD_PRODUCT_UPDATE_FILES_FAILURE';
export const GET_PRODUCT_UPDATE_BARCODES_BEGIN = 'GET_PRODUCT_UPDATE_BARCODES_BEGIN';
export const GET_PRODUCT_UPDATE_BARCODES_SUCCESS = 'GET_PRODUCT_UPDATE_BARCODES_SUCCESS';
export const GET_PRODUCT_UPDATE_BARCODES_FAILURE = 'GET_PRODUCT_UPDATE_BARCODES_FAILURE';
export const SET_UPDATED_PRODUCTS_BARCODES_DATA = 'SET_UPDATED_PRODUCTS_BARCODES_DATA';
export const GET_HISTORY_BEGIN = 'GET_HISTORY_BEGIN';
export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS';
export const GET_HISTORY_FAILURE = 'GET_HISTORY_FAILURE';
export const SET_UPLOADS_HISTORY_DATA = 'SET_UPLOADS_HISTORY_DATA';
export const GET_SUMMARY_REPORT_TABLE_BEGIN = 'GET_SUMMARY_REPORT_TABLE_BEGIN';
export const GET_SUMMARY_REPORT_TABLE_FAILURE = 'GET_SUMMARY_REPORT_TABLE_FAILURE';
export const GET_SUMMARY_REPORT_TABLE_SUCCESS = 'GET_SUMMARY_REPORT_TABLE_SUCCESS';
export const SET_SUMMARY_REPORT_TABLE_DATA = 'SET_SUMMARY_REPORT_TABLE_DATA';
export const GET_REPORT_TEMPLATE_BEGIN = 'GET_REPORT_TEMPLATE_BEGIN';
export const GET_REPORT_TEMPLATE_FAILURE = 'GET_REPORT_TEMPLATE_FAILURE';
export const GET_REPORT_TEMPLATE_SUCCESS = 'GET_REPORT_TEMPLATE_SUCCESS';
export const SET_REPORT_TEMPLATE = 'SET_REPORT_TEMPLATE';
export const GET_REPORT_BEGIN = 'GET_REPORT_BEGIN';
export const GET_REPORT_FAILURE = 'GET_REPORT_FAILURE';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const SET_REPORT = 'SET_REPORT';
export const SET_AVAILABLE_SUPPLIERS = 'SET_AVAILABLE_SUPPLIERS';
export const SET_AVAILABLE_LOCATIONS = 'SET_AVAILABLE_LOCATIONS';
export const SAVE_REPORT_BEGIN = 'SAVE_REPORT_BEGIN';
export const SAVE_REPORT_SUCCESS = 'SAVE_REPORT_SUCCESS';
export const SAVE_REPORT_FAILURE = 'SAVE_REPORT_FAILURE';
export const SET_CREATED_REPORT_ID = 'SET_CREATED_REPORT_ID';
export const SET_CREATED_REPORT_SUPPLIER = 'SET_CREATED_REPORT_SUPPLIER';
export const SET_CREATED_REPORT_MONTH = 'SET_CREATED_REPORT_MONTH';
export const SET_CREATED_REPORT_ORDERPERIOD = 'SET_CREATED_REPORT_ORDERPERIOD';
export const OPEN_DETAILS_TABLE_IN_WINDOW = 'OPEN_DETAILS_TABLE_IN_WINDOW';
export const CLOSE_DETAILS_TABLE_WINDOW = 'CLOSE_DETAILS_TABLE_WINDOW';
export const OPEN_SUMMARY_TABLE_IN_WINDOW = 'OPEN_SUMMARY_TABLE_IN_WINDOW';
export const CLOSE_SUMMARY_TABLE_WINDOW = 'CLOSE_SUMMARY_TABLE_WINDOW';
export const OPEN_ORDERING_TABLE_IN_WINDOW = 'OPEN_ORDERING_TABLE_IN_WINDOW';
export const CLOSE_ORDERING_TABLE_WINDOW = 'CLOSE_ORDERING_TABLE_WINDOW';
export const SET_PRODUCT_CHANGES = 'SET_PRODUCT_CHANGES';



// WEBPACK FOOTER //
// ./src/store/types.js